import React, { lazy, Suspense } from 'react'
import { HashRouter as Router, Routes, Route } from 'react-router-dom'
import { Provider } from 'mobx-react'
import { ConfigProvider } from 'antd'
import 'moment/locale/zh-cn'
import locale from 'antd/es/locale/zh_CN'
import Loading from 'components/Loading'
import stores from './stores'
import './styles/index.less'

const BasicLayout = lazy(() => import('./Layout/BasicLayout'))
const Login = lazy(() => import('./pages/Login'))
const ForgotUpw = lazy(() => import('./pages/ForgotUpw'))

export default function App() {
  return (
    <Provider {...stores}>
      <Suspense fallback={<Loading content="加载中..." />}>
        <Router>
          <ConfigProvider locale={locale}>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/forgotUpw" element={<ForgotUpw />} />
              <Route path="/*" element={<BasicLayout />} />
            </Routes>
          </ConfigProvider>
        </Router>
      </Suspense>
    </Provider>
  )
}
